import { render, staticRenderFns } from "./PortalDocumentEdit.vue?vue&type=template&id=406e05ca&"
import script from "./PortalDocumentEdit.vue?vue&type=script&lang=js&"
export * from "./PortalDocumentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports